import {useMutation} from '@tanstack/react-query'

import {usePdsClient} from '#/state/session'
import {com} from '#/lexicons'

export function useRequestEmailVerification() {
  const client = usePdsClient()

  return useMutation({
    mutationFn: async () => {
      await client.call(com.atproto.server.requestEmailConfirmation)
    },
  })
}
